/* 2026-09-01 (Claude) - Laufzeit-Patches zu den Mobile-Bugs vom 01.09.
   Warum nicht direkt in theme.js: die Datei ist zu gross fuer einen
   Schreibvorgang ueber die Admin-API. Diese Datei wird VOR theme.js
   geladen und korrigiert genau zwei Stellen.
   Rueckgaengig machen: Datei loeschen und die eine script-Zeile in
   layout/theme.liquid entfernen. */
(function () {
  'use strict';

  /* Bug 2: Ruckeln beim Scrollen.
     theme.js haengt onScrollFrame ungedrosselt an das scroll-Event. Pro
     Event wird scrollHeight gelesen und danach nav.style.top und die
     Breite von #scrollProg geschrieben - Lesen nach Schreiben erzwingt
     in jedem Frame ein neues Layout.
     Hier wird genau dieser eine Listener in requestAnimationFrame
     gewickelt. Der Eingriff ist eng gefasst: nur type "scroll", nur die
     Funktion namens onScrollFrame, und danach wird addEventListener
     sofort wieder auf das Original zurueckgesetzt. */
  var proto = EventTarget.prototype;
  var orig = proto.addEventListener;

  proto.addEventListener = function (type, fn, opts) {
    if (type === 'scroll' && typeof fn === 'function' && fn.name === 'onScrollFrame') {
      var inner = fn;
      var ticking = false;
      fn = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; inner(); });
      };
      proto.addEventListener = orig;
    }
    return orig.call(this, type, fn, opts);
  };

  /* Sicherheitsnetz: falls theme.js sich aendert und der Name nicht mehr
     passt, laeuft der Patch ins Leere - dann spaetestens hier zurueck. */
  window.addEventListener('load', function () {
    proto.addEventListener = orig;
  }, { once: true });

  /* Bug 3, zweite Haelfte: abgebrochene Wischgesten.
     sliderInit() merkt sich bei pointerdown die X-Position und wertet sie
     erst bei pointerup aus. Bricht der Browser die Geste ab, kommt nie
     ein pointerup - der Startwert bleibt stehen und die naechste Geste
     wird falsch gemessen. touch-action: pan-y (fix-0901.css) verhindert
     den Abbruch in den meisten Faellen; hier wird der Rest abgefangen,
     indem ein abgebrochener Zeiger als pointerup mit Delta 0 nachgereicht
     wird - der Slider springt also nicht, setzt sich aber zurueck. */
  var startX = null;
  var startRoot = null;

  document.addEventListener('pointerdown', function (e) {
    var root = e.target && e.target.closest ? e.target.closest('[data-bs-slider]') : null;
    startRoot = root;
    startX = root ? e.clientX : null;
  }, { capture: true, passive: true });

  document.addEventListener('pointercancel', function () {
    if (!startRoot || startX === null) return;
    try {
      startRoot.dispatchEvent(new PointerEvent('pointerup', {
        clientX: startX, bubbles: true, cancelable: true
      }));
    } catch (err) { /* aeltere Browser ohne PointerEvent-Konstruktor */ }
    startRoot = null;
    startX = null;
  }, { capture: true, passive: true });

  /* Lemon Berry: Akzentfarbe nachreichen.
     theme.js hat eine fest verdrahtete Farbkarte, die nur Stadtnamen kennt
     (Monaco, Vienna, Paris …). findCity() liefert für "Lemon Berry" null,
     also bleibt die Sorte ohne Akzent. Da theme.js nicht schreibbar ist,
     steht der Eintrag hier. Gelb ist die einzige freie Zone der Palette -
     die rot-rosa Ecke ist mit Paris, Tokio und Madrid schon belegt.
     Der Original-Handler tut für diesen Namen nichts, es gibt also keinen
     Konflikt zwischen beiden. */
  var EXTRA = { 'lemon berry': '#EBC93F' };

  function extraAccent(text) {
    var t = (text || '').toLowerCase();
    for (var key in EXTRA) { if (t.indexOf(key) >= 0) return EXTRA[key]; }
    return null;
  }

  document.addEventListener('pointerover', function (e) {
    var c = e.target && e.target.closest ? e.target.closest('.ed') : null;
    if (!c) return;
    var col = extraAccent(c.textContent);
    if (!col) return;
    c.classList.add('city-hot');
    c.style.setProperty('--accent-city', col);
    document.documentElement.style.setProperty('--accent-city', col);
  }, { passive: true });

  if (document.body.getAttribute('data-tpl') === 'product') {
    var head = document.querySelector('.pdp .kicker, .pdp-sub, .pdp h1');
    var pcol = head && extraAccent(head.textContent);
    if (pcol) document.documentElement.style.setProperty('--accent-city', pcol);
  }
})();